<template>
<span>
  <p><span style="background-color:#ffffff"><span style="font-size:10pt">Inhalt der Leistung:</span></span></p>

  <ul>
    <li>
      <p><span style="background-color:#ffffff"><span style="font-size:10pt">Berechnen der Trennungsabstandsberechnung bei bestehenden Blitzschutzsysteme</span></span></p>
    </li>
    <li>
      <p><span style="background-color:#ffffff"><span style="font-size:10pt">Textliche und zeichnerische Darstellung der Trennungsabst&auml;nde</span></span></p>
    </li>
  </ul>

  <p><span style="background-color:#ffffff"><span style="font-size:9pt"><em>Hinweis: Ein bestehendes Blitzschutzsystem ist Voraussetzung f&uuml;r diese Leistung.</em></span></span></p>
</span>
</template>

<script>
export default {
  name: "TooltipTrennungsabstandsberechnung"
}
</script>

<style scoped>

</style>
